<template>
  <div class="data-not-found">{{ message || 'No Data Found' }}</div>
</template>

<script>
export default {
  props: ["message"],
};
</script>
<style lang="scss" scoped>
.data-not-found {
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: #e2e5ea;
  background-color: #fff;
}
</style>